import {Component, OnInit} from '@angular/core';
import {Dad, DadSubscriberData} from '../../../models/dad';
import {DadService} from '../../../services/dad.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../../../authenticationModule/services/authentication.service';
import {BaseClientComponent} from '../../../../components/base-client.component';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from '../../../../appSharedModule/services/utils.service';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-dad-form',
  templateUrl: './dad-form.component.html',
  styleUrls: ['./dad-form.component.scss']
})
export class DadFormComponent extends BaseClientComponent implements OnInit {

  currentDad: Dad;
  previousMonthSubscriptionData: DadSubscriberData = null;
  originalClientDeclarationMode = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private dadService: DadService,
    private router: Router,
    protected http: HttpClient,
    protected utilsService: UtilsService,
    public authenticationService: AuthenticationService
  ) {
    super();
  }

  ngOnInit() {
    const response = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.getSelectedDad();
    });
    this.subscriptions.push(response);
  }

  private getSelectedDad() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.dadService.getDadByUniqid(params.get('dadUniqid')).subscribe(
        res => {
          this.currentDad = res[0];
          if (params.get('original') && params.get('original') === 'original') {
            if (this.currentDad.decodedOriginalClientDeclaration) {
              this.originalClientDeclarationMode = true;
            } else {
              this.redirectionToNotFound();
            }
          }
          if (!this.currentDad || this.currentDad.isSelfReported) {
            this.redirectionToNotFound();
            return;
          }
          if (this.currentDad.markets.length === 0
            || !(this.authenticationService.userCurrent.roles.includes('ROLE_MCKAY')
              || this.currentDad.status === 'Draft' || this.currentDad.status === 'Passed Due')) {
            this.redirectionToNotFound();
            return;
          }
          this.dadService.getPreviousMonthDad(this.currentDad.uniqid).subscribe(
            previousMonthSubscriptionData => {
              this.previousMonthSubscriptionData = previousMonthSubscriptionData;
            }
          );
        }
      );
    });
  }

  redirectionToNotFound() {
    this.router.navigate(['/404']);
  }

  getUserCurrent() {
    return this.authenticationService.getUserCurrent();
  }

  protected getWarningText() {
    const dadConfig = this.currentDad.dadConfig;
    const month = new Date(this.currentDad.createdAt);
    month.setDate(month.getDate() + 3);
    const date = dadConfig.quincyCutoffStartDay + ' ' + month.toLocaleString('en-US', {month: 'long'});
    if (!dadConfig.quincyCutoffStartTime) {
      return '';
    }
    const time = this.getTimeFromDateString(dadConfig.quincyCutoffStartTime);
    return 'Important: This form will no longer be editable after ' + date + ' ' + time + ' (' + dadConfig.timezone + ')';
  }

  private getTimeFromDateString(str: string): string | undefined {
    const m = str.match(/([Zz]|[+-]\d{2}:\d{2})$/);
    if (!m) {
      return formatDate(str, 'HH:mm', 'en-US');
    }
    const offsetFromIso = m[1].toUpperCase() === 'Z' ? '+0000' : m[1].replace(':', '');
    return formatDate(str, 'HH:mm', 'en-US', offsetFromIso);
  }
}
